// Column widths for the Gantt time axis, kept out of GanttChart.jsx so that
// file only exports components and stays eligible for fast refresh.

// Fixed steps rather than a fit-to-width formula. The chart this replaced
// squashed a long project until its bars were unreadable; a Gantt is meant to
// scroll. 16px is closest to the reference workbook's own column width.
export const ZOOMS = { compact: 9, normal: 16, wide: 26 }

export function defaultZoom(dayCount) {
  if (dayCount <= 90) return 'wide'
  if (dayCount <= 220) return 'normal'
  return 'compact'
}
